import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Popconfirm, Table, Form } from "antd";
import React, { useEffect } from "react";
import { Controller, useFieldArray } from "react-hook-form";
import RentableAreaSelect from "Components/rentablearea-select";
import { RULES } from "Constants/rules";

export default function RentableAreaList({
  form,
  singleMode = false,
  options = { contractType: null },
  ...props
}) {
  const { fields: rentableAreas, append, remove } = useFieldArray({
    control: form.control,
    name: "rentableAreas",
  });

  const errors = form.errors;
  const watch = form.watch;

  const columns = [
    {
      title: "Kiralanabilir Alan",
      dataIndex: ["rentableAreas", "id"],
      editable: true,

      render: (text, record, index) => {
        return (
          <Form.Item
            style={{ margin: 0 }}
            hasFeedback={true}
            validateStatus={
              errors.measures && errors.rentableArea[index]?.id && "error"
            }
          >
            <RentableAreaSelect
              form={form}
              defaultValue={rentableAreas[index]?.rentableArea || null}
              field={`rentableAreas[${index}].rentableArea`}
              params={
                options.contractType?.rule?.code === RULES.RULE0001 //Rule Yapısı: Lojman Sozlemesi ise
                  ? {
                      ruleCode: RULES.RULE0005, //Rule Yapısı: Kiralanabilir alan turu lojman ise
                    }
                  : null
              }
            />
          </Form.Item>
        );
      },
    },
    {
      title: "İşlemler",
      dataIndex: "operation",
      width: 100,
      fixed: "right",
      render: (text, record, index) => {
        return (
          <>
            {/* useArrayField yapılarında, itemdaki değişikliği gönderebilmek için hidden bir input
                alanında Id değerini tutmak ve formOnSubmitde bu idyi kullanarak nesneleri mergelemeliyiz*/}
            <Controller
              control={form.control}
              name={`rentableAreas[${index}].id`}
              as={<Input type="hidden" />}
            />
            <Popconfirm
              title="Emin Misin?"
              onConfirm={() => {
                remove(index);
              }}
              icon={<FontAwesomeIcon icon={["far", "trash-alt"]} />}
              okText="Kaldır"
              cancelText="Geri"
            >
              <Button type="danger">
                <FontAwesomeIcon icon={["far", "trash-alt"]} />
              </Button>
            </Popconfirm>
          </>
        );
      },
    },
  ];

  return (
    <Table
      size="small"
      scroll={{ x: 300, y: 300 }}
      bordered
      rowKey={(row) => row.id}
      title={() => {
        return (
          <Button
            key="add"
            disabled={singleMode && rentableAreas.length > 0}
            onClick={() => {
              append({});
            }}
          >
            <FontAwesomeIcon icon={["fas", "plus"]} />
          </Button>
        );
      }}
      dataSource={rentableAreas}
      columns={columns}
    />
  );
}
